import script from "./DCDeleteStreak.vue?vue&type=script&setup=true&lang=ts"
export * from "./DCDeleteStreak.vue?vue&type=script&setup=true&lang=ts"

import "./DCDeleteStreak.vue?vue&type=style&index=0&id=13ed47f0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13ed47f0"]])

export default __exports__